import './styles/App.css';
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from 'swiper/modules';
import { importAll } from "./utils/importImages";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const images = importAll(
  require.context("./images/galerie", false, /\.(png|jpe?g|svg|webp)$/)
);

console.log(images)


function Galerie() {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <div className="carousel-container">
        <Swiper
            modules={[Navigation, Thumbs]}
            navigation
            thumbs={{ swiper: thumbsSwiper }}
            className="main-swiper"
            spaceBetween={10}
            slidesPerView={1}
        >
            {images.map((img, i) => (
            <SwiperSlide key={i}>
                <img src={img.logo} alt={`${i + 1}`} className="main-image" />
            </SwiperSlide>
            ))}
        </Swiper>

        <Swiper
            onSwiper={setThumbsSwiper}
            modules={[Thumbs]}
            spaceBetween={5}
            slidesPerView="auto"
            freeMode={true}
            watchSlidesProgress
            className="thumbs-swiper"
            >
            {images.map((img, i) => (
                <SwiperSlide key={i} style={{ width: "auto" }}>
                <img src={img.logo} alt={`Miniature ${i + 1}`} className="thumbnail" />
                </SwiperSlide>
            ))}
        </Swiper>
        </div>
    );
}

export default Galerie;